<template>
  <master-layout class="rca">
    <v-container class="content-container background-gradient">
      <v-container fluid class="component-container-1400mw">
        <v-container class="centered-horizontally">
          <loading-dialog :message="messageLoadingDialog" :show-dialog="showLoadingDialog"/>
          <!--          <rca-no-offers-dialog :showDialog="showNoOffersDialog"/>-->
          <auth-already-exists-login-dialog
              :email="customerForm.email"
              :user-already-exists-with-email="userAlreadyExistsWithEmail"
              @loggedIn="handleUserLoggedIn"
          >
          </auth-already-exists-login-dialog>
          <v-stepper
              tile
              rounded="0"
              elevation="0"
              :items="stepperItems"
              class="rca-stepper"
              selected-class="active"
              v-model="activeStep"
              :hide-actions="true"
          >
            <template v-slot:item.1>
              <div>
                <v-row>
                  <v-col cols="12" sm="auto" md="6" class="d-flex flex-column justify-start centered-on-mobile">
                    <h3 class="font-weight-bold">
                      {{ translation(translationList.which_car_to_insure, 'Ce masină vrei să asiguri?') }}</h3>
                    <p class="font-weight-regular">
                      {{
                        translation(translationList.recommend_scan_vehicle_document, 'Îți recomandăm scanarea talonului pentru completare automată.')
                      }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="auto" md="6" class="d-flex justify-end centered-on-mobile">
                    <upload-document
                        :txtPlaceholder="translation(translationList.which_car_to_insure, 'Scanează talonul')"
                        :documentId="documentList.vehicle_registration_id"
                        @ocr-response="handleOcrResponse"
                    >
                    </upload-document>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6" v-show="!isTemporaryRegistered">
                    <registration-plate v-model="vehicleForm.registration_plate"
                                        @on-county-code-extracted="handleCountyCodeExtractedFromRegistrationPlate"
                                        @validation-vehicle-status="handleValidationVehicleStatus"></registration-plate>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vin v-model="vehicleForm.vin" @validation-vehicle-status="handleValidationVehicleStatus"></vin>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-type-select v-model="vehicleForm.vehicle_type"
                                         @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-type-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-civ-code v-model="vehicleForm.civ_code"
                                      @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-civ-code>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-category-select v-model="vehicleForm.rca_mapped_category"
                                             @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-category-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-usage-type-select v-model="vehicleForm.usage_type"
                                               @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-usage-type-select>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-make-select v-model="vehicleForm.make"
                                         :vehicle-category-ws-id="vehicleForm.rca_mapped_category ? vehicleForm.rca_mapped_category.ws_id : null"
                                         @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-make-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-model-select v-model="vehicleForm.model"
                                          :vehicle-make-id="vehicleForm.make ? vehicleForm.make.id : null"
                                          @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-model-select>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-manufacture-year-select
                        v-model="vehicleForm.manufacture_year"
                        @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-manufacture-year-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-fuel-type-select v-model="vehicleForm.fuel_type"
                                              :is-readonly="isFuelTypeReadOnly"
                                              @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-fuel-type-select>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-cylinder v-model="vehicleForm.cylinder"
                                      :is-readonly="isCylinderReadOnly"
                                      @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-cylinder>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-power v-model="vehicleForm.power"
                                   :is-readonly="isPowerReadOnly"
                                   @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-power>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="6">
                    <vehicle-max-weight v-model="vehicleForm.max_weight"
                                        @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-max-weight>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vehicle-number-of-seats v-model="vehicleForm.number_of_seats"
                                             :is-readonly="isNumberOfSeatsReadOnly"
                                             @validation-vehicle-status="handleValidationVehicleStatus"></vehicle-number-of-seats>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12">
                    <h3 class="font-weight-bold">{{
                        translation(translationList.policy_preference, 'Preferințe asigurare')
                      }}</h3>
                    <p class="font-weight-regular">
                      {{
                        translation(translationList.period_of_time, 'Pe ce perioadă dorești asigurarea? Poți selecta mai multe perioade pentru a putea compara prețurile, majoritatea șoferilor aleg 12 luni.')
                      }}
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12">
                    <rca-radio-availability
                        v-model="rcaForm.availability"
                        @validation-rca-status="handleValidationRcaStatus"
                    >
                    </rca-radio-availability>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12" sm="12" md="6">
                    <rca-valid-from v-model="rcaForm.valid_from" @validation-rca-status="handleValidationRcaStatus">
                    </rca-valid-from>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    {{
                      translation(translationList.info_valid_from, 'Data de start a poliței trebuie să înceapă în următoarea zi dupa efectuarea plății. Te rugăm să efectuezi plata cât mai curând.')
                    }}
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12">
                    <rca-gdpr-agreement v-model="rcaForm.gdpr_agreement"
                                        @validation-rca-status="handleValidationRcaStatus"></rca-gdpr-agreement>
                  </v-col>
                </v-row>
                <v-row class="mt-10 mb-15">
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <v-btn
                        class="block-on-mobile"
                        color="primary"
                        size="x-large"
                        flat
                        rounded="0"
                        @click="validateStep(1)"
                    >{{ translation(translationList.continue, 'Continuă') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </template>
            <template v-slot:item.2>
              <div>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <rca-is-vehicle-in-leasing-tab
                        v-model="vehicleForm.is_vehicle_in_leasing"
                        @validation-vehicle-status="handleValidationVehicleStatus"
                    ></rca-is-vehicle-in-leasing-tab>
                  </v-col>
                </v-row>
                <v-row cols="12" sm="auto" md="12" v-show="vehicleForm.is_vehicle_in_leasing">
                  <v-col cols="12">
                    <rca-leasing-company-select
                        v-model="vehicleForm.leasing_company"
                        @validation-vehicle-status="handleValidationVehicleStatus"
                    ></rca-leasing-company-select>
                  </v-col>
                </v-row>
                <v-row class="mt-10">
                  <v-col cols="12" sm="12" md="6">
                    <customer-type-tab v-model="customerForm.is_legal"></customer-type-tab>
                  </v-col>
                </v-row>
                <v-row v-show="vehicleForm.is_vehicle_in_leasing">
                  <v-col cols="12">
                    <h3 class="font-weight-bold">
                      {{ translation(translationList.user_data, 'Date utilizator') }}
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <customer-rca-agreement v-model="customerForm.customer_agreement"
                                            :is-legal="<boolean>customerForm.is_legal"
                                            @validation-rca-status="handleValidationCustomerStatus"></customer-rca-agreement>
                  </v-col>
                </v-row>

                <v-row v-if="!customerForm.is_legal" class="mt-3">
                  <v-col cols="12" sm="12" md="6" class="d-flex flex-column justify-start centered-on-mobile">
                    <h3 class="font-weight-bold">
                      <span v-if="!vehicleForm.is_vehicle_in_leasing">
                        {{ translation(translationList.user_data, 'Date utilizator') }}
                      </span>
                    </h3>
                    <p class="font-weight-regular">
                      <span v-if="!vehicleForm.is_vehicle_in_leasing">
                        {{
                          translation(translationList.customer_data_helper, 'Completează datele personale ale proprietarului')
                        }}
                      </span>
                      <span v-else>
                        {{
                          translation(translationList.customer_data_helper, 'Completează datele personale ale utilizatorului')
                        }}
                      </span>
                    </p>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" class="d-flex justify-end centered-on-mobile">
                    <upload-document
                        txtPlaceholder="Incarca buletin"
                        :documentId="documentList.identity_card_id"
                        @ocr-response="handleOcrResponse"
                    >
                    </upload-document>
                  </v-col>
                </v-row>

                <div v-show="!customerForm.is_legal">
                  <v-row class="mt-5">
                    <v-col cols="12" sm="12" md="6">
                      <customer-last-name v-model="customerForm.last_name"
                                          @validation-customer-status="handleValidationCustomerStatus"></customer-last-name>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <customer-first-name v-model="customerForm.first_name"
                                           @validation-customer-status="handleValidationCustomerStatus"></customer-first-name>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3" v-if="!user">
                    <v-col cols="12" sm="12" md="6">
                      <customer-email v-model="customerForm.email"
                                      @validation-customer-status="handleValidationCustomerStatus"></customer-email>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <customer-phone-number v-model="customerForm.phone_number"
                                             @validation-customer-status="handleValidationCustomerStatus"></customer-phone-number>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col cols="12" sm="12" md="4">
                      <customer-cnp v-model="customerForm.cnp"
                                    @validation-customer-status="handleValidationCustomerStatus"></customer-cnp>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <customer-series-ci v-model="customerForm.series_ci"
                                          @validation-customer-status="handleValidationCustomerStatus"></customer-series-ci>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <customer-nr-ci v-model="customerForm.nr_ci"
                                      @validation-customer-status="handleValidationCustomerStatus"></customer-nr-ci>
                    </v-col>
                  </v-row>
                </div>
                <div v-show="customerForm.is_legal" class="mt-3">
                  <v-row class="mt-5">
                    <v-col cols="12" sm="12" md="6" class="d-flex flex-column justify-start centered-on-mobile">
                      <h3 class="font-weight-bold">
                        {{ translation(translationList.customer_data, 'Date firmă') }}</h3>
                      <p class="font-weight-regular">
                        {{
                          translation(translationList.customer_data_helper, 'Completează datele firmei')
                        }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="">
                    <v-col cols="12" sm="12" md="6">
                      <customer-cif-code v-model="customerForm.cif_code"
                                         @validation-customer-status="handleValidationCustomerStatus"></customer-cif-code>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <customer-company-name v-model="customerForm.company_name"
                                             @validation-customer-status="handleValidationCustomerStatus"></customer-company-name>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5">
                    <v-col cols="12" sm="12" md="12">
                      <customer-caen-code-select v-model="customerForm.caen_code"
                                                 @validation-customer-status="handleValidationCustomerStatus"></customer-caen-code-select>
                    </v-col>
                  </v-row>
                  <v-row class="my-3" v-if="!user">
                    <v-col cols="12" sm="12" md="6">
                      <customer-email v-model="customerForm.email"
                                      @validation-customer-status="handleValidationCustomerStatus"></customer-email>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <customer-phone-number v-model="customerForm.phone_number"
                                             @validation-customer-status="handleValidationCustomerStatus"></customer-phone-number>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mt-10">
                  <v-col cols="12" sm="12" md="6">
                    <customer-is-same-driver-tab
                        v-model="customerForm.is_same_driver"
                        :is-legal="customerForm.is_legal"
                        :number-of-other-drivers="customerForm.number_of_other_drivers"
                    >
                    </customer-is-same-driver-tab>
                  </v-col>
                </v-row>

                <div v-if="customerForm.number_of_other_drivers">
                  <v-row class="pb-5">
                    <v-col cols="12" sm="12" md="6" class="d-flex flex-column justify-start centered-on-mobile">
                      <h3 class="font-weight-bold">
                        {{ translation(translationList.drivers_no, 'Număr soferi') }}</h3>
                      <p class="font-weight-regular">
                        {{
                          translation(translationList.travelers_no_helper, 'Selectează câți soferi vor conduce mașina.')
                        }}
                      </p>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="d-flex align-center justify-end centered-on-mobile">
                      <v-btn
                          min-width="0"
                          size="small"
                          icon="mdi-minus"
                          color="primary-light"
                          variant="flat"
                          :disabled="(customerForm.number_of_other_drivers ?? 0) <= 1"
                          @click="customerForm.number_of_other_drivers = (customerForm.number_of_other_drivers ?? 1) - 1"
                      >
                      </v-btn>
                      <div class="mx-2 fw-500">
                        {{ customerForm.number_of_other_drivers }}
                      </div>
                      <v-btn
                          min-width="0"
                          size="small"
                          icon="mdi-plus"
                          color="primary"
                          flat
                          @click="customerForm.number_of_other_drivers = (customerForm.number_of_other_drivers ?? 0) + 1"
                          :disabled="(customerForm.number_of_other_drivers ?? 0) >= 5"
                      >
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="6" class="d-flex flex-column justify-start centered-on-mobile">
                      <h3 class="font-weight-bold">
                        {{ translation(translationList.drivers_info, 'Informații despre soferi') }}</h3>
                      <p class="font-weight-regular">
                        {{
                          translation(translationList.drivers_info_helper, 'Completează detalii esențiale despre soferi.')
                        }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-expansion-panels color="primary-light" v-model="activePanels" rounded="0" variant="accordion"
                                      class="mt-3">
                    <v-expansion-panel eager class="w-100" v-for="(driver, index) in customerForm.other_drivers"
                                       :key="index">
                      <v-expansion-panel-title>
                        <template v-slot:default="{ expanded }">
                          <v-row class="d-flex align-center" no-gutters>
                            <v-col class="d-flex justify-start my-1" cols="12" sm="3" md="2">
                              <h3 class="font-weight-bold text-primary">
                                {{ translation(translationList.driver, 'Șofer') }} #{{ index + 1 }}</h3>
                            </v-col>
                            <v-col class="my-1" cols="12" sm="9" md="10">
                              <v-fade-transition leave-absolute>
                                <h4 v-if="!expanded" class="font-weight-bold text-contrast">
                                  {{ driver.last_name }} {{ driver.first_name }} </h4>
                              </v-fade-transition>
                            </v-col>
                          </v-row>
                        </template>
                      </v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <v-row>
                          <v-col cols="12" sm="auto" md="6"
                                 class="d-flex flex-column justify-start centered-on-mobile">
                            <p class="font-weight-regular">
                              {{
                                translation(translationList.travel_user_helper, 'Completează datele personale și adresa conform documentului de identitate.')
                              }}
                            </p>
                          </v-col>
                        </v-row>
                        <v-row class="d-flex align-center">
                          <v-col cols="12" sm="12" md="6">
                            <customer-last-name v-model="driver.last_name"
                                                @validation-customer-status="handleValidationDriverStatus"
                                                :customerIndex="index"></customer-last-name>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <customer-first-name v-model="driver.first_name"
                                                 :customerIndex="index"
                                                 @validation-customer-status="handleValidationDriverStatus"
                            ></customer-first-name>
                          </v-col>
                        </v-row>
                        <v-row class="d-flex align-center">
                          <v-col sm="12" md="4">
                            <customer-cnp v-model="driver.cnp" :customerIndex="index"
                                          @validation-customer-status="handleValidationDriverStatus"
                            ></customer-cnp>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <customer-series-ci v-model="driver.series_ci" :customerIndex="index"
                                                @validation-customer-status="handleValidationDriverStatus"
                            ></customer-series-ci>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <customer-nr-ci v-model="driver.nr_ci" :customerIndex="index"
                                            @validation-customer-status="handleValidationDriverStatus"
                            ></customer-nr-ci>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="12">
                    <h3 class="font-weight-bold">
                      {{ translation(translationList.address, 'Adresa din talon') }}
                    </h3>
                    <p class="font-weight-regular">
                      {{ translation(translationList.address_helper, 'Completează adresa din talonul mașinii.') }}
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="6">
                    <address-county-select
                        v-model="vehicleForm.address.county"
                        @validation-address-status="handleValidationAddressStatus"
                        :is-county-read-only="isCountyReadOnly"

                    ></address-county-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <address-city-select
                        v-model="vehicleForm.address.city"
                        :county-id="vehicleForm.address.county ? vehicleForm.address.county.id : null"
                        @validation-address-status="handleValidationAddressStatus"
                    >
                    </address-city-select>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="4">
                    <address-street v-model="vehicleForm.address.street"
                                    @validation-address-status="handleValidationAddressStatus"></address-street>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <address-street-number v-model="vehicleForm.address.street_number"
                                           @validation-address-status="handleValidationAddressStatus"></address-street-number>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <address-postal-code v-model="vehicleForm.address.postal_code"
                                         @validation-address-status="handleValidationAddressStatus"
                                         :is-postal-code-auto-completed="isPostalCodeAutoCompleted"
                    ></address-postal-code>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="4">
                    <address-building v-model="vehicleForm.address.building"
                                      @validation-address-status="handleValidationAddressStatus"></address-building>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <address-entrance v-model="vehicleForm.address.entrance"
                                      @validation-address-status="handleValidationAddressStatus"></address-entrance>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <address-apartment v-model="vehicleForm.address.apartment"
                                       @validation-address-status="handleValidationAddressStatus"></address-apartment>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="6" class="d-flex justify-start centered-on-mobile">
                    <v-btn
                        class="block-on-mobile"
                        color="primary-light"
                        size="x-large"
                        flat
                        rounded="0"
                        @click="backToStep(1)"
                    >
                      {{ translation(translationList.step, 'Pasul') }}
                      {{ translation(translationList.previous, 'Anterior') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" class="d-flex justify-end centered-on-mobile">
                    <v-btn
                        class="block-on-mobile"
                        color="primary"
                        size="x-large"
                        flat
                        rounded="0"
                        @click="validateStep(2)"
                    >
                      {{ translation(translationList.view, 'Vezi') }}
                      {{ translation(translationList.offers, 'Oferte') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </template>
            <template v-slot:item.3>
              <div>
                <v-row class="mt-5">
                  <v-col cols="12">
                    <div class="fw-400 fs-20">
                      {{
                        translation(translationList.perfect_choice_rca, 'Perfect! Iată cele mai bune oferte pentru mașina ta. Compară si alege opțiunea dorită.')
                      }}
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="6">
                    <rca-is-deducted-tab v-model="offerForm.is_deducted"></rca-is-deducted-tab>
                  </v-col>
                </v-row>

                <div v-if="insuranceCompanies" class="mt-10 mb-10">
                  <div class="mt-5" v-for="(insuranceCompany, index) in insuranceCompanies" :key="index">
                    <div
                        v-if="offers && Object.keys(offers).length > 0 && offers[insuranceCompany.id] && offers[insuranceCompany.id].some((subArray: ApiOffer[]) => Array.isArray(subArray) && subArray.some((offer: ApiOffer) => offer && offer.error === false))">
                      <rca-offer-row
                          :insurance-company="insuranceCompany"
                          :offer="typeof offers[insuranceCompany.id] !== 'undefined' ? offers[insuranceCompany.id] : null"
                          :is-deducted="offerForm.is_deducted"
                          :availability="rcaForm.availability"
                      >
                      </rca-offer-row>
                    </div>
                  </div>
                </div>

                <div v-if="isLoadingSkeleton" class="mt-10 mb-10">
                  <v-skeleton-loader type="image"></v-skeleton-loader>
                </div>

                <div v-if="!isLoadingSkeleton && showNoOffersDialog" class="mt-10 mb-10">
                  <v-icon color="primary" size="x-large">mdi-information</v-icon>
                  {{
                    translation(translationList.rca_offer_not_available, 'Din păcate, nu am reușit să identificăm o ofertă. Probabil că datele introduse de tine nu sunt corecte.')
                  }}
                </div>

                <v-row class="mt-5" v-if="rcaBaarValidation && rcaBaarValidation.message">
                  <v-col cols="12" sm="12">
                    <v-alert
                        :type="rcaBaarValidation.is_high_risk ? 'warning' : 'success'"
                        class="text-center"
                    >
                      <div v-html="rcaBaarValidation.message"></div>
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row class="mt-5" v-show="!isLoadingSkeleton">
                  <v-col cols="12" sm="12" md="6" class="d-flex justify-start centered-on-mobile">
                    <v-btn
                        class="block-on-mobile"
                        color="primary-light"
                        size="x-large"
                        flat
                        rounded="0"
                        @click="backToStep(2)"
                    >
                      {{ translation(translationList.step, 'Pasul') }}
                      {{ translation(translationList.previous, 'Anterior') }}
                    </v-btn>
                  </v-col>
                  <v-col v-if="!showNoOffersDialog && false" cols="12" sm="12" md="6"
                         class="d-flex justify-end centered-on-mobile">
                    <v-btn
                        class="block-on-mobile"
                        color="primary"
                        size="x-large"
                        flat
                        rounded="0"
                        @click="sendOffersToUser()"
                        v-show="!isOffersMailSent "
                    >{{ translation(translationList.send_comparator_to_mail, 'Trimite comparația pe email') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </template>
          </v-stepper>
        </v-container>
      </v-container>
    </v-container>
  </master-layout>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from 'vue';
import MasterLayout from "~/layouts/MasterLayout.vue";
import RegistrationPlate from "~/components/vehicle/RegistrationPlate.vue";
import Vin from "~/components/vehicle/Vin.vue";
import VehicleTypeSelect from "~/components/vehicle/VehicleTypeSelect.vue";
import {translation, useTranslationStore} from '~/plugins/store/translations';
import VehicleCivCode from "~/components/vehicle/VehicleCivCode.vue";
import VehicleCategorySelect from "~/components/vehicle/VehicleCategorySelect.vue";
import VehicleUsageTypeSelect from "~/components/vehicle/VehicleUsageTypeSelect.vue";
import VehicleMakeSelect from "~/components/vehicle/VehicleMakeSelect.vue";
import {useRoute, useRouter} from "vue-router";
import {useVehicleStore} from "~/plugins/store/vehicle";
import {useRcaStore} from "~/plugins/store/rca";
import {useAuthStore} from "~/plugins/store/auth";
import {useDocumentStore} from "~/plugins/store/document";
import {
  type ApiVehicleAddress,
  type ApiVehicleDetails,
  type ApiVehicleDriver,
  type ApiVehicleOwner,
  createDefaultApiVehicleAddress,
  createDefaultApiVehicleDetails,
  createDefaultApiVehicleOwner,
  createDefaultRcaVehicleForm,
  createDefaultRcaVehicleFormValidation,
  type RcaVehicleForm,
  type RcaVehicleFormValidation
} from "~/types/Vehicle";
import UploadDocument from "~/components/utils/UploadDocument.vue";
import {useNuxtApp} from "#app";
import {
  type ApiCompanyData,
  createDefaultApiCompanyData,
  createDefaultRcaCustomerFormValidation,
  defaultRcaCustomerForm,
  type RcaCustomerForm,
  type RcaCustomerFormValidation,
  type RcaDriverFormValidation,
  type RcaDriversFormValidation
} from "~/types/Customer";
import CustomerCnp from "~/components/customer/CustomerCnp.vue";
import CustomerSeriesCi from "~/components/customer/CustomerSeriesCi.vue";
import CustomerNrCi from "~/components/customer/CustomerNrCi.vue";
import CustomerEmail from "~/components/customer/CustomerEmail.vue";
import CustomerCifCode from "~/components/customer/CustomerCifCode.vue";
import CustomerCompanyName from "~/components/customer/CustomerCompanyName.vue";
import CustomerIsSameDriverTab from "~/components/customer/CustomerIsSameDriverTab.vue";
import CustomerCaenCode from "~/components/customer/CustomerCaenCode.vue";
import {type AddressFormValidation, createDefaultAddressFormValidation} from "~/types/Address";
import AddressStreet from "~/components/address/AddressStreet.vue";
import AddressStreetNumber from "~/components/address/AddressStreetNumber.vue";
import AddressBuilding from "~/components/address/AddressBuilding.vue";
import AddressEntrance from "~/components/address/AddressEntrance.vue";
import AddressPostalCode from "~/components/address/AddressPostalCode.vue";
import {
  createDefaultOfferForm,
  createDefaultRcaForm,
  createDefaultRcaFormValidation,
  type OfferForm, type RcaBaarValidation,
  type RcaForm,
  type RcaFormValidation,
  type RcaInsuranceCompany
} from "~/types/Rca";
import AuthAlreadyExistsLoginDialog from "~/components/auth/AuthAlreadyExistsLoginDialog.vue";
import {useProductStore} from "~/plugins/store/product";
import type {OcrResponse, TranslationList} from "~/types/Utils";
import {useAddressStore} from "~/plugins/store/address";
import {recaptcha} from '~/composables/recaptcha';
import {useReCaptcha} from "vue-recaptcha-v3";
import {useCompanyStore} from "~/plugins/store/company";
import CustomerCaenCodeSelect from "~/components/customer/CustomerCaenCodeSelect.vue";
import CustomerPhoneNumber from "~/components/customer/CustomerPhoneNumber.vue";
import LoadingDialog from "~/components/utils/LoadingDialog.vue";
import type {Product} from "~/types/Product";
import type {ApiOffer} from "~/types/Rca"; //it is used in template, do not delete

export default defineComponent({
  components: {
    LoadingDialog,
    CustomerPhoneNumber,
    CustomerCaenCodeSelect,
    AuthAlreadyExistsLoginDialog,
    AddressPostalCode,
    AddressEntrance,
    AddressBuilding,
    AddressStreetNumber,
    AddressStreet,
    CustomerCaenCode,
    CustomerIsSameDriverTab,
    CustomerCompanyName,
    CustomerCifCode,
    CustomerEmail,
    CustomerNrCi,
    CustomerSeriesCi,
    CustomerCnp,
    UploadDocument,
    VehicleMakeSelect,
    VehicleUsageTypeSelect,
    VehicleCategorySelect,
    VehicleCivCode,
    RegistrationPlate,
    Vin,
    VehicleTypeSelect,
    MasterLayout,
  },
  setup() {
    useHead({
      title: '24Broker | RCA',
      meta: [
        {
          name: 'description',
          content: 'Compară ofertele de asigurare RCA de la toate companiile majore din România și achiziționează polița perfectă pentru tine, rapid și simplu, online.'
        }
      ],
    });

    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});
    const route = useRoute();
    const router = useRouter();
    const vehicleStore = useVehicleStore();
    const addressStore = useAddressStore();
    const rcaStore = useRcaStore();
    const documentStore = useDocumentStore();
    const authStore = useAuthStore();
    const user = ref(authStore.getUser());
    let accessToken = authStore.getAccessToken();
    const {$toast} = useNuxtApp();
    const userAlreadyExistsWithEmail = ref(false);
    const isLoadingSkeleton = ref(false);
    const isOffersMailSent = ref(false);
    const documentList = ref(documentStore.documentList);
    const productStore = useProductStore();
    let rcaProduct = <Product>({});
    const recaptchaInstance = useReCaptcha();
    const companySore = useCompanyStore();
    const apiCompanyData = ref<ApiCompanyData>(createDefaultApiCompanyData());
    const showNoOffersDialog = ref(false);
    const showLoadingDialog = ref(false);
    const messageLoadingDialog = ref('');

    const isCountyReadOnly = ref(false);
    const isCylinderReadOnly = ref(false);
    const isPowerReadOnly = ref(false);
    const isNumberOfSeatsReadOnly = ref(false);
    const isFuelTypeReadOnly = ref(false);
    const isPostalCodeAutoCompleted = ref(false);
    const rcaBaarValidation = ref<RcaBaarValidation|null>(null);

    const scrollToTop = () => {
      const {$scrollToTop} = useNuxtApp();
      $scrollToTop();
    }

    const stepperItems = ref(
        [
          {
            title: translation(translationList.value.vehicle_details, 'Detalii vehicul'),
            rules: [() => false],
          },
          {
            title: translation(translationList.value.owner_details, 'Detalii proprietar'),
          },
          {
            title: translation(translationList.value.comparator, 'Comparator'),
          }
        ]);

    const activeStep = ref(1);
    const activePanels = ref([0]);

    const {$dayjs} = useNuxtApp();
    const now = $dayjs();
    const minDate = now.add(1, 'day').format('YYYY-MM-DD');
    const maxNumberOfOtherDrivers = ref(3);

    const vehicleForm = ref<RcaVehicleForm>(createDefaultRcaVehicleForm());

    const validationVehicleStatus = ref<RcaVehicleFormValidation>(createDefaultRcaVehicleFormValidation());

    const validationAddressStatus = ref<AddressFormValidation>(createDefaultAddressFormValidation());

    const rcaForm = ref<RcaForm>(createDefaultRcaForm());
    rcaForm.value.valid_from = minDate;

    const validationRcaStatus = ref<RcaFormValidation>(createDefaultRcaFormValidation());

    const offerForm = ref<OfferForm>(createDefaultOfferForm());

    const customerForm = ref<RcaCustomerForm>(defaultRcaCustomerForm());

    const validationCustomerStatus = ref<RcaCustomerFormValidation>(createDefaultRcaCustomerFormValidation());
    const validationDriversStatus = ref<RcaDriversFormValidation>({});

    const isSearched = ref(false);
    const insuranceCompanies = ref<RcaInsuranceCompany[]>([]);
    const offers = ref<{ [key: string]: any }>({});

    onMounted(async () => {
      if (typeof route.params.registration_plate === 'string') {
        vehicleForm.value.registration_plate = route.params.registration_plate.toUpperCase();

        // Verifică dacă URL-ul curent conține parametrul și elimină-l dacă este cazul
        const currentPath = window.location.pathname;
        const basePath = '/rca'; // Path-ul de bază pe care îl dorești fără parametri

        if (currentPath.startsWith(`${basePath}/`)) {
          // Asigură-te că rămâne doar calea de bază
          const newUrl = `${window.location.origin}${basePath}`;

          // Păstrează starea existentă din history.state
          const currentState = history.state;
          history.replaceState(currentState, '', newUrl);
        }
      }
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      if (user.value) {
        customerForm.value.email = user.value.email;
        validationCustomerStatus.value.email = true;
        customerForm.value.phone_number = user.value.phone_number;
        validationCustomerStatus.value.phone_number = true;
      }

      if (!productStore.productStatuses.is_rca_available) {
        navigateTo('/product-unavailable');
      }

      rcaProduct = await productStore.getRcaProduct();
    });

    const handleValidationVehicleStatus = ({field, isValid}: { field: string, isValid: boolean }) => {
      validationVehicleStatus.value[field] = isValid;
    };

    const handleValidationDriverStatus = ({field, isValid}: { field: string, isValid: boolean }) => {
      const [baseField, index] = field.split('-');

      if (index !== undefined) {
        const numericIndex = Number(index);
        if (isNaN(numericIndex)) {
          console.error('Invalid index:', index);
          return;
        }

        if (!validationDriversStatus.value[numericIndex]) {
          validationDriversStatus.value[numericIndex] = {
            last_name: false,
            first_name: false,
            cnp: false,
            series_ci: false,
            nr_ci: false,
          };
        }

        const driverValidation = validationDriversStatus.value[numericIndex] as RcaDriverFormValidation;
        driverValidation[baseField] = isValid;

      }
    };

    const handleValidationCustomerStatus = ({field, isValid}: { field: string, isValid: boolean }) => {
      validationCustomerStatus.value[field] = isValid;
    };


    const handleValidationAddressStatus = ({field, isValid}: { field: string, isValid: boolean }) => {
      validationAddressStatus.value[field] = isValid;
    };
    const handleValidationRcaStatus = ({field, isValid}: { field: string, isValid: boolean }) => {
      validationRcaStatus.value[field] = isValid;
    };

    const handleOcrResponse = async ({response, documentId}: { response: OcrResponse, documentId: number }) => {
      switch (documentId) {
        case documentList.value.vehicle_registration_id:
          const apiVehicleDetails = createDefaultApiVehicleDetails();
          apiVehicleDetails.registration_plate = response.registration_plate;
          apiVehicleDetails.vin = response.vin;
          apiVehicleDetails.manufacture_year = response.manufacture_year;
          apiVehicleDetails.max_weight = response.max_weight ? parseInt(response.max_weight) : null;
          apiVehicleDetails.cylinder = response.cylinder ? parseInt(response.cylinder) : null;
          apiVehicleDetails.power = response.power ? parseInt(response.power) : null;
          apiVehicleDetails.number_of_seats = response.number_of_seats ? parseInt(response.number_of_seats) : null;
          apiVehicleDetails.civ_code = response.civ_code;
          apiVehicleDetails.vehicle_rar_category_id = response.vehicle_rar_category_id ? parseInt(response.vehicle_rar_category_id) : null;
          apiVehicleDetails.rca_mapped_category_id = response.rca_mapped_category ? response.rca_mapped_category.id : null;
          apiVehicleDetails.rca_vehicle_make_id = response.rca_vehicle_make ? response.rca_vehicle_make.id : null;
          apiVehicleDetails.rca_vehicle_model_id = response.rca_vehicle_model ? response.rca_vehicle_model.id : null;
          apiVehicleDetails.vehicle_fuel_type_id = response.vehicle_fuel_type ? response.vehicle_fuel_type.id : null;
          apiVehicleDetails.rca_vehicle_make_name = response.rca_vehicle_make ? response.rca_vehicle_make.name : null;
          apiVehicleDetails.rca_vehicle_model_name = response.rca_vehicle_model ? response.rca_vehicle_model.name : null;
          apiVehicleDetails.default_vehicle_address = null;
          apiVehicleDetails.rca_vehicle_make = response.rca_vehicle_make;
          apiVehicleDetails.rca_vehicle_model = response.rca_vehicle_model;
          apiVehicleDetails.vehicle_fuel_type = response.vehicle_fuel_type;
          apiVehicleDetails.rca_mapped_category = response.rca_mapped_category;

          const apiVehicleAddress = createDefaultApiVehicleAddress();
          apiVehicleAddress.street = response.address.street ? response.address.street : null;
          apiVehicleAddress.street_number = response.address.street ? response.address.street : null;
          apiVehicleAddress.building = response.address.building ? response.address.building : null;
          apiVehicleAddress.entrance = response.address.entrance ? response.address.entrance : null;
          apiVehicleAddress.apartment = response.address.apartment ? response.address.apartment : null;
          apiVehicleAddress.country = response.address.country ? response.address.country : null;
          apiVehicleAddress.county = response.address.county ? response.address.county : null;
          apiVehicleAddress.city = response.address.city ? response.address.city : null;

          apiVehicleDetails.default_vehicle_address = apiVehicleAddress;

          await fillVehicleDetails(apiVehicleDetails);
          break;
        case documentList.value.identity_card_id:

          const apiVehicleOwner = createDefaultApiVehicleOwner();
          apiVehicleOwner.last_name = response.last_name ? response.last_name : null;
          apiVehicleOwner.first_name = response.first_name ? response.first_name : null;
          apiVehicleOwner.cnp = response.cnp ? response.cnp : null;
          apiVehicleOwner.series_ci = response.series_ci ? response.series_ci : null;
          apiVehicleOwner.nr_ci = response.nr_ci ? response.nr_ci : null;
          await fillCustomerDetails(apiVehicleOwner);
          break;
      }
    };

    const fillVehicleDetails = async (vehicleDetails: ApiVehicleDetails) => {
      const fieldsMap: { [key: string]: keyof ApiVehicleDetails } = {
        vin: 'vin',
        civ_code: 'civ_code',
        rca_mapped_category: 'rca_mapped_category',
        usage_type: 'vehicle_usage_type',
        make: 'rca_vehicle_make',
        model: 'rca_vehicle_model',
        fuel_type: 'vehicle_fuel_type',
        cylinder: 'cylinder',
        power: 'power',
        max_weight: 'max_weight',
        number_of_seats: 'number_of_seats',
        manufacture_year: 'manufacture_year',
        leasing_company: 'rca_leasing_company',
      };

      for (const [formField, detailField] of Object.entries(fieldsMap)) {
        const detailValue = vehicleDetails[detailField];

        if (formField === 'rca_mapped_category') {
          // Specific logic for rca_mapped_category
          if (detailValue !== null && detailValue !== (vehicleForm.value as any)[formField]) {
            (vehicleForm.value as any)[formField] = detailValue;
          }
        } else {
          // General logic for all other fields
          if (detailValue !== null) {
            (vehicleForm.value as any)[formField] =
                formField === 'manufacture_year' && typeof detailValue === 'string'
                    ? parseInt(detailValue)
                    : detailValue;
          }
        }
      }

      // Check for leasing_company and set is_vehicle_in_leasing
      if (vehicleDetails.rca_leasing_company) {
        vehicleForm.value.is_vehicle_in_leasing = true;
      }
    };

    const fillCustomerDetails = async (customerDetails: ApiVehicleOwner) => {
      const fieldsMap: { [key: string]: keyof ApiVehicleOwner } = {
        last_name: 'last_name',
        first_name: 'first_name',
        cnp: 'cnp',
        series_ci: 'series_ci',
        nr_ci: 'nr_ci',
        email: 'email',
        company_name: 'company_name',
        caen_code: 'caen_code',
        cif_code: 'cif_code',
      };

      for (const [formField, detailField] of Object.entries(fieldsMap)) {
        const detailValue = customerDetails[detailField];
        if (
            detailValue !== null
        ) {
          (customerForm.value as any)[formField] = detailValue;

          // Set is_legal to true if company_name is filled
          if (formField === 'company_name') {
            customerForm.value.is_legal = true;
          }
        }
      }
    };

    const fillAddressDetails = async (addressDetails: ApiVehicleAddress) => {
      const fieldsMap: { [key: string]: keyof ApiVehicleAddress } = {
        county: 'county',
        city: 'city',
        street: 'street',
        street_number: 'street_number',
        postal_code: 'postal_code',
        building: 'building',
        entrance: 'entrance',
        apartment: 'apartment',
      };

      for (const [formField, detailField] of Object.entries(fieldsMap)) {
        const detailValue = addressDetails[detailField];
        if (
            detailValue !== null
        ) {
          (vehicleForm.value.address as any)[formField] = detailValue;
        }
      }
    };

    watch(() => vehicleForm.value.registration_plate, async (newValue, oldValue) => {
      if (newValue && newValue.length
          && newValue !== oldValue) {
        //if we have vin or civ_code we need to clear them, because we are searching by a new registration_plate
        if (vehicleForm.value.vin) {
          vehicleForm.value.vin = null;
        }
        if (vehicleForm.value.civ_code) {
          vehicleForm.value.civ_code = '';
        }
        await retrieveVehicleDetails(newValue, null);
      }
    });

    watch(() => customerForm.value.is_legal, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        if (newValue) {
          customerForm.value.first_name = null;
          customerForm.value.last_name = null;
          customerForm.value.cnp = null;
          customerForm.value.series_ci = null;
          customerForm.value.nr_ci = null;
        } else {
          customerForm.value.company_name = null;
          customerForm.value.cif_code = null;
          customerForm.value.caen_code = null;
        }
      }
    });

    watch(() => vehicleForm.value.vin, async (newValue, oldValue) => {
      if (newValue && newValue.length && newValue !== oldValue
          && validationVehicleStatus.value.vin
          && !isVehicleDetailsFound.value) {
        await retrieveVehicleDetails(null, newValue);
      }
    });

    const isVehicleDetailsFound = ref(false);
    let isUpdatingDrivers = false;

    const retrieveVehicleDetails = async (registrationPlate: string | null, vin: string | null) => {
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.vehicle_details_searching, 'Căutăm detaliile mașinii...');
      const token = await recaptcha(recaptchaInstance);
      const result = await vehicleStore.fetchVehicleDetails(registrationPlate, vin, accessToken, token);

      if (result) {
        isSearched.value = true;
        isVehicleDetailsFound.value = true;
        $toast.success(translation(translationList.value.vehicle_details_found, 'Detaliile mașinii au fost găsite!'));
        await fillVehicleDetails(result);
        if (result.vehicle_owner) {
          await fillCustomerDetails(result.vehicle_owner);
        }
        if (result.default_vehicle_address) {
          await fillAddressDetails(result.default_vehicle_address);
        }
        if (result.vehicle_vehicle_drivers) {
          for (const driver of result.vehicle_vehicle_drivers) {
            if (!driver.is_owner && !driver.is_legal) {
              isUpdatingDrivers = true;
              await fillDriverDetails(driver);
              isUpdatingDrivers = false;
            }
          }
        }
      } else {
        isVehicleDetailsFound.value = false;
        $toast.error(translation(translationList.value.vehicle_details_not_found, 'Detaliile masinii nu au fost gasite!'));
      }
      isSearched.value = false;
      showLoadingDialog.value = false;
    };

    const fillDriverDetails = async (driver: ApiVehicleDriver) => {
      const driverDetails = {
        last_name: driver.last_name,
        first_name: driver.first_name,
        cnp: driver.cnp,
        series_ci: driver.series_ci,
        nr_ci: driver.nr_ci,
      };
      customerForm.value.number_of_other_drivers = customerForm.value.number_of_other_drivers
          ? customerForm.value.number_of_other_drivers + 1
          : 1;
      customerForm.value.is_same_driver = false;
      if (customerForm.value.other_drivers) {
        customerForm.value.other_drivers.push(driverDetails);
      } else {
        customerForm.value.other_drivers = [driverDetails];
      }
    };

    watch(() => vehicleForm.value.rca_mapped_category, async (newValue, oldValue) => {
      if (newValue && newValue.code === vehicleStore.vehicleCategoryTow.code) {
        isCylinderReadOnly.value = true;
        vehicleForm.value.cylinder = 0;
        isPowerReadOnly.value = true;
        vehicleForm.value.power = 0;
        isNumberOfSeatsReadOnly.value = true;
        vehicleForm.value.number_of_seats = 0;
        isFuelTypeReadOnly.value = true;
        vehicleForm.value.fuel_type = vehicleStore.vehicleFuelTypeWithout;
      } else {
        isCylinderReadOnly.value = false;
        if (vehicleForm.value.cylinder === 0 && !isSearched.value) {
          vehicleForm.value.cylinder = null;
        }
        isPowerReadOnly.value = false;
        if (vehicleForm.value.power === 0 && !isSearched.value) {
          vehicleForm.value.power = null;
        }
        isNumberOfSeatsReadOnly.value = false;
        if (vehicleForm.value.number_of_seats === 0 && !isSearched.value) {
          vehicleForm.value.number_of_seats = null;
        }
        isFuelTypeReadOnly.value = false;
        if ((vehicleForm.value.fuel_type?.code === vehicleStore.vehicleFuelTypeWithout.code || vehicleForm.value.fuel_type?.code === vehicleStore.vehicleFuelTypeElectric.code) && !isSearched.value) {
          vehicleForm.value.fuel_type = null;
        }
      }
    });

    watch(() => vehicleForm.value.fuel_type, async (newValue, oldValue) => {
      if (newValue && (newValue.code === vehicleStore.vehicleFuelTypeElectric.code || newValue.code === vehicleStore.vehicleFuelTypeWithout.code)) {
        isCylinderReadOnly.value = true;
        vehicleForm.value.cylinder = 0;
        if (newValue.code === vehicleStore.vehicleFuelTypeWithout.code) {
          isPowerReadOnly.value = true;
          if (!isSearched.value) {
            vehicleForm.value.power = 0;
          }
        }
        if (newValue.code === vehicleStore.vehicleFuelTypeElectric.code) {
          isPowerReadOnly.value = false;
          if (!isSearched.value) {
            vehicleForm.value.power = null;
          }
        }
      } else {
        isCylinderReadOnly.value = false;
        if (vehicleForm.value.cylinder === 0) {
          vehicleForm.value.cylinder = null;
        }
        isPowerReadOnly.value = false;
        if (vehicleForm.value.power === 0) {
          vehicleForm.value.power = null;
        }
      }
    });

    const isTemporaryRegistered = computed(() => vehicleForm.value.vehicle_type ? (vehicleForm.value.vehicle_type.code === "temporaryRegistered") : false);

    watch(() => customerForm.value.email, async (newValue, oldValue) => {
      if (newValue !== oldValue && !user.value && newValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newValue)) {
        const token = await recaptcha(recaptchaInstance);
        userAlreadyExistsWithEmail.value = newValue ? await authStore.checkEmailExists(newValue, token) : false;
      }
    });

    watch(() => vehicleForm.value.address.city, async (newValue, oldValue) => {
      if (newValue && newValue !== oldValue) {
        if (newValue.postal_code) {
          vehicleForm.value.address.postal_code = newValue.postal_code;
          isPostalCodeAutoCompleted.value = true;
        }
      }
    });

    watch(() => customerForm.value.cif_code, async (newValue, oldValue) => {
      if (newValue && newValue.length && newValue !== oldValue) {
        showLoadingDialog.value = true;
        messageLoadingDialog.value = translation(translationList.value.company_details_searching, 'Cautam detaliile companiei...');
        const token = await recaptcha(recaptchaInstance);
        apiCompanyData.value = await companySore.fetchCompanyData(newValue, token);
        await clearCompanyData();
        fillCompanyData();
        showLoadingDialog.value = false;
      }
    });

    watch(() => vehicleForm.value.is_vehicle_in_leasing, async (newValue, oldValue) => {
      if (newValue !== oldValue
          && vehicleForm.value.registration_plate
          && vehicleForm.value.address.county
      ) {
        isCountyReadOnly.value = !newValue;
      }
    });

    const clearCompanyData = async () => {
      customerForm.value.company_name = null;
      validationCustomerStatus.value.company_name = false;
      customerForm.value.caen_code = null;
      validationCustomerStatus.value.caen_code = false;
      vehicleForm.value.address.city = null;
      validationAddressStatus.value.city = false;
      vehicleForm.value.address.street = null;
      validationAddressStatus.value.street = false;
      vehicleForm.value.address.street_number = null;
      validationAddressStatus.value.street_number = false;
      vehicleForm.value.address.postal_code = null;
      validationAddressStatus.value.postal_code = false;
    };

    const fillCompanyData = () => {
      if (apiCompanyData.value) {
        $toast.success(translation(translationList.value.company_details_found, 'Detaliile companiei au fost gasite!'));
        if (apiCompanyData.value.company_name && !customerForm.value.company_name) {
          customerForm.value.company_name = apiCompanyData.value.company_name;
        }
        if (apiCompanyData.value.caen_code && !customerForm.value.caen_code) {
          customerForm.value.caen_code = apiCompanyData.value.caen_code;
        }

        if (apiCompanyData.value.county && vehicleForm.value.address.county
            && apiCompanyData.value.county.code === vehicleForm.value.address.county.code) {
          if (apiCompanyData.value.city && !vehicleForm.value.address.city) {
            vehicleForm.value.address.city = apiCompanyData.value.city;
          }
          if (apiCompanyData.value.street_name && !vehicleForm.value.address.street) {
            vehicleForm.value.address.street = apiCompanyData.value.street_name;
          }
          if (apiCompanyData.value.street_number && !vehicleForm.value.address.street_number) {
            vehicleForm.value.address.street_number = apiCompanyData.value.street_number;
          }
          if (apiCompanyData.value.street_number && !vehicleForm.value.address.postal_code) {
            vehicleForm.value.address.postal_code = apiCompanyData.value.postal_code;
          }
        } else {
          $toast.info(translation(translationList.value.registered_office_different, 'Județul de înmatriculare este diferit de cel al societății, vă rugăm să completați adresa punctului de lucru care să corespundă cu județul de înmatriculare.'));
        }
      } else {
        $toast.error(translation(translationList.value.company_details_not_found, 'Detaliile companiei nu au fost gasite!'));
      }
    };

    const handleCountyCodeExtractedFromRegistrationPlate = async (countyCode: string) => {
      if (countyCode && !vehicleForm.value.address.county) {
        const counties = await addressStore.getCounties();
        const county = counties.find(c => c.code === countyCode);
        if (county) {
          vehicleForm.value.address.county = county;
          if (!vehicleForm.value.is_vehicle_in_leasing) {
            isCountyReadOnly.value = true;
          }
        }
      }
    };

    const handleUserLoggedIn = async () => {
      const newUser = authStore.getUser();
      $toast.success(translation(translationList.value.successfully_logged_in, 'Te-ai logat cu succes!'));
      accessToken = authStore.getAccessToken();
      userAlreadyExistsWithEmail.value = false;
      user.value = newUser;
      fillUserData();
    };

    const fillUserData = () => {
      if (user.value) {
        customerForm.value.email = user.value.email;
        validationCustomerStatus.value.email = true;
        customerForm.value.phone_number = user.value.phone_number;
        validationCustomerStatus.value.phone_number = true;
      }
    }

    const validateStep = async (step: number) => {
      switch (step) {
        case 1:
          scrollToTop();
          showLoadingDialog.value = true;
          messageLoadingDialog.value = translation(translationList.value.vehicle_details_validating, 'Validăm datele masinii...');

          // Validate vehicle form fields
          const vehicleFields = [
            'registration_plate',
            'rca_mapped_category',
            'civ_code',
            'vehicle_type',
            'usage_type',
            'vin',
            'make',
            'model',
            'manufacture_year',
            'fuel_type',
            'cylinder',
            'power',
            'max_weight',
            'number_of_seats'
          ];

          const isVehicleFormValid = (() => {
            let allValid = true;
            vehicleFields.forEach(field => {
              if (field === 'registration_plate' && isTemporaryRegistered.value) {
                return;
              }

              // Exception for vehicleCategoryTow
              if (vehicleForm.value.rca_mapped_category
                  && vehicleForm.value.rca_mapped_category.id === vehicleStore.vehicleCategoryTow.id) {
                if (['power', 'number_of_seats', 'cylinder'].includes(field)) {
                  return;
                }
              }

              // Exception for electric fuel type
              if (vehicleForm.value.fuel_type?.code === vehicleStore.vehicleFuelTypeElectric.code) {
                if (field === 'cylinder') {
                  return;
                }
              }

              if (!validationVehicleStatus.value[field]) {
                console.log('Validation failed for field: ', field);
                window.dispatchEvent(new CustomEvent('validate-vehicle', {detail: field}));
                allValid = false;
              }
            });
            return allValid;
          })();

          // Validate RCA form fields
          const rcaFields = ['availability', 'valid_from', 'gdpr_agreement'];

          const isRcaFormValid = (() => {
            let allValid = true;
            rcaFields.forEach(field => {
              if (!validationRcaStatus.value[field]) {
                console.log('Validation failed for field: ', field);
                window.dispatchEvent(new CustomEvent('validate-rca', {detail: field}));
                allValid = false;
              }
            });
            return allValid;
          })();

          if (!isVehicleFormValid || !isRcaFormValid) {
            $toast.error(translation(translationList.value.fill_all_fields, 'Te rugăm să completezi toate câmpurile obligatorii corect!'));
            showLoadingDialog.value = false;
            return;
          }

          activeStep.value = 2;
          showLoadingDialog.value = false;
          break;

        case 2:
          scrollToTop();
          showLoadingDialog.value = true;
          messageLoadingDialog.value = translation(translationList.value.customer_details_validating, 'Validăm datele introduse...');

          // Validate customer form fields
          const customerFields = customerForm.value.is_legal
              ? ['company_name', 'caen_code', 'cif_code']
              : ['last_name', 'first_name', 'cnp', 'series_ci', 'nr_ci'];

          customerFields.push('email');
          customerFields.push('phone_number');
          customerFields.push('customer_agreement');

          const isCustomerFormValid = (() => {
            let allValid = true;
            customerFields.forEach(field => {
              if (!validationCustomerStatus.value[field]) {
                console.log('Validation failed for field: ', field);
                window.dispatchEvent(new CustomEvent('validate-customer', {detail: field}));
                allValid = false;
              }
            });
            return allValid;
          })();

          // Validate vehicle form fields
          const secondVehicleFields = ['is_vehicle_in_leasing', 'leasing_company'];

          const isSecondVehicleFormValid = (() => {
            let allValid = true;
            secondVehicleFields.forEach(field => {
              if (vehicleForm.value.is_vehicle_in_leasing && !validationVehicleStatus.value[field]) {
                console.log('Validation failed for field: ', field);
                window.dispatchEvent(new CustomEvent('validate-vehicle', {detail: field}));
                allValid = false;
              }
            });
            return allValid;
          })();

          // Validate dynamic other_drivers fields
          const areOtherDriversValid = validateOtherDrivers();


          // Validate address fields
          const addressFields = ['county', 'city', 'street', 'street_number', 'postal_code'];

          const isAddressValid = (() => {
            let allValid = true;
            addressFields.forEach(field => {
              if (!validationAddressStatus.value[field]) {
                console.log('Validation failed for field: ', field);
                window.dispatchEvent(new CustomEvent('validate-address', {detail: field}));
                allValid = false;
              }
            });
            return allValid;
          })();

          if (!isCustomerFormValid || !isSecondVehicleFormValid || !areOtherDriversValid || !isAddressValid) {
            $toast.error(translation(translationList.value.fill_all_fields, 'Te rugăm să completezi toate câmpurile obligatorii corect!'));
            showLoadingDialog.value = false;
            return;
          }

          if (!user.value) {
            const token = await recaptcha(recaptchaInstance);
            const tmpAuthResponse = await authStore.storeUserFromProductPage(customerForm.value, rcaProduct.id, token);
            if (tmpAuthResponse) {
              accessToken = tmpAuthResponse.access_token;
              userAlreadyExistsWithEmail.value = false;
              user.value = tmpAuthResponse.user;
              validationCustomerStatus.value.email = true;
              validationCustomerStatus.value.phone_number = true;
            }
          }
          const token = await recaptcha(recaptchaInstance);
          await vehicleStore.storeVehicle(vehicleForm.value, customerForm.value, accessToken, token);
          if (vehicleStore.vehicle) {
            vehicleForm.value.id = vehicleStore.vehicle.id;
          }
          let availabilities = '';
          if (Array.isArray(rcaForm.value.availability)) {
            availabilities = rcaForm.value.availability.join(',');
          } else if (rcaForm.value.availability) {
            availabilities = rcaForm.value.availability.toString();
          }
          if (vehicleForm.value.vehicle_type && vehicleForm.value.vehicle_type.id) {
            await rcaStore.fetchRcaInsuranceCompanies(vehicleForm.value.vehicle_type.id, availabilities);
          }
          insuranceCompanies.value = rcaStore.insuranceCompanies;
          activeStep.value = 3;
          showLoadingDialog.value = false;
          break;
      }
    };

    const validateOtherDrivers = () => {
      let areOtherDriversValid = true;

      // Verificăm dacă sunt șoferi adăugați și dacă numărul acestora este valid
      if (customerForm.value.number_of_other_drivers && customerForm.value.other_drivers
          && customerForm.value.number_of_other_drivers > 0) {
        areOtherDriversValid = customerForm.value.other_drivers.every((_, index) => {
          let isValid = true;
          const driverFields = ['last_name', 'first_name', 'cnp', 'series_ci', 'nr_ci'];

          // Verificăm validarea fiecărui câmp pentru șoferul curent
          const driverValidation = validationDriversStatus.value[index];
          if (driverValidation) {
            driverFields.forEach(field => {
              const fieldStatus = driverValidation[field];
              if (!fieldStatus) {
                console.log('Validation failed for field:', `${field}-${index}`);
                window.dispatchEvent(new CustomEvent('validate-customer', {detail: `${field}-${index}`}));
                isValid = false;
              }
            });
          } else {
            // Dacă nu există validare pentru acest index, marcăm ca invalid
            console.log('No validation status found for driver index:', index);
            driverFields.forEach(field => {
              console.log('Validation failed for field:', `${field}-${index}`);
              window.dispatchEvent(new CustomEvent('validate-customer', {detail: `${field}-${index}`}));
            });
            isValid = false;
          }

          return isValid;
        });
      }

      return areOtherDriversValid;
    };

    const handleOffersResponse = async (company: RcaInsuranceCompany) => {
      const token = await recaptcha(recaptchaInstance);
      const tmpResponse = await rcaStore.fetchOffers(
          company,
          vehicleForm.value,
          customerForm.value,
          rcaForm.value,
          accessToken,
          token
      );

      if (tmpResponse && Array.isArray(tmpResponse)) {
        const hasValidOffer = tmpResponse.some(response => {
          let isValid = false;
          for (let key in response) {
            if (typeof response[key] !== 'undefined'
                && typeof response[key] === 'object') {
              if (!response[key].error) {
                isValid = true;
                break;
              }
            }
          }
          return isValid;
        });
        if (hasValidOffer) {
          offers.value[company.id] = tmpResponse;
        }
      }
    };


    watch(() => insuranceCompanies.value, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        isLoadingSkeleton.value = true;

        const promises = insuranceCompanies.value.map(async (company: RcaInsuranceCompany) => {
          if (company && company.id) {
            await handleOffersResponse(company);
          }
        });

        await Promise.all(promises);

        showNoOffersDialog.value = Object.keys(offers.value).length === 0;
        isLoadingSkeleton.value = false;

        const offerCodes: string[] = [];

        Object.values(offers.value).forEach((offerGroups: any) => {
          offerGroups.forEach((offerGroup: any) => {
            offerGroup.forEach((offer: any) => {
              if (offer.rca_availability_id === "12" && offer.is_deducted === false) {
                offerCodes.push(offer.code);
              }
            });
          });
        });

        if (offerCodes.length >= 3) {
          rcaBaarValidation.value = await rcaStore.validateBaar(offerCodes);
        } else {
          console.warn('Validation skipped: At least 3 offer codes are required.');
        }
      }
    });


    watch(() => customerForm.value.is_same_driver, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        if (newValue) {
          customerForm.value.number_of_other_drivers = 0;
        } else {
          customerForm.value.number_of_other_drivers = 1;
        }
      }
    });

    watch(() => customerForm.value.number_of_other_drivers, async (newValue, oldValue) => {
      if (isUpdatingDrivers || newValue === oldValue || newValue === null || oldValue === null) return;

      if (!customerForm.value.other_drivers) {
        customerForm.value.other_drivers = [];
      }

      if (newValue > oldValue) {
        customerForm.value.other_drivers.push({
          last_name: null,
          first_name: null,
          cnp: null,
          series_ci: null,
          nr_ci: null,
        });
      } else if (newValue < oldValue && customerForm.value.other_drivers.length > 0) {
        customerForm.value.other_drivers.pop();
      }
    });

    const backToStep = (step: number) => {
      activeStep.value = step;
      if (step === 2) {
        //reset offers
        offers.value = {};
        rcaBaarValidation.value = null;
        isOffersMailSent.value = false;
      }
    };

    const sendOffersToUser = async () => {
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.sending_offers, 'Trimitem ofertele...');
      const token = await recaptcha(recaptchaInstance);
      const response = await rcaStore.sendOffersToUser(
          offers.value,
          insuranceCompanies.value,
          <boolean>offerForm.value.is_deducted,
          <string>customerForm.value.email,
          <number>vehicleForm.value.id,
          accessToken,
          token
      );
      if (response) {
        isOffersMailSent.value = true;
        $toast.success(translation(translationList.value.offers_sent_success, 'Comparatorul a fost trimis pe email!'));
      } else {
        $toast.error(translation(translationList.value.error, 'A apărut o eroare.'));
        console.error('comparatorul nu a fost trimis pe email');
      }
      showLoadingDialog.value = false;
    };

    return {
      validationDriversStatus,
      translationList,
      translation,
      vehicleForm,
      customerForm,
      rcaForm,
      validateStep,
      isTemporaryRegistered,
      stepperItems,
      activeStep,
      maxNumberOfOtherDrivers,
      insuranceCompanies,
      offers,
      offerForm,
      user,
      handleValidationCustomerStatus,
      handleValidationDriverStatus,
      validationCustomerStatus,
      handleValidationVehicleStatus,
      validationVehicleStatus,
      handleValidationAddressStatus,
      validationAddressStatus,
      handleValidationRcaStatus,
      validationRcaStatus,
      userAlreadyExistsWithEmail,
      handleUserLoggedIn,
      isLoadingSkeleton,
      documentList,
      handleOcrResponse,
      backToStep,
      handleCountyCodeExtractedFromRegistrationPlate,
      sendOffersToUser,
      isOffersMailSent,
      showNoOffersDialog,
      showLoadingDialog,
      messageLoadingDialog,
      activePanels,
      isCountyReadOnly,
      isCylinderReadOnly,
      isPowerReadOnly,
      isNumberOfSeatsReadOnly,
      isFuelTypeReadOnly,
      isPostalCodeAutoCompleted,
      rcaBaarValidation
    };
  },
});
</script>

<style scoped>
</style>
